import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'markant-platform-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
})
export class ErrorDialogComponent {
  @Input() open = false;

  @Input() headTitle$!: Observable<string>;
  @Input() text$!: Observable<string>;

  @Input() buttonLabel$!: Observable<string>;
  @Input() buttonCallback!: () => void;
  @Input() closeCallback!: () => void;

  closeDialog(): void {
    this.closeCallback();
  }
}
